import { FindingsExpandableComponent } from 'Components/organisms';
import { EngagementChannelExpandable } from 'Components/organisms';
import { UserCohort } from 'Components/organisms';
import TagFiltersExpandable from 'Components/organisms/TagFiltersExpandable/TagFiltersExpandable';
import { isPendingEngagementsFilterByFindingsEnabled } from 'Core-utils/featureFlags/pendingEngagementsFilterByFindings';
import { MenuItem, Row } from 'Core-utils/types';
import { TagFilterBuckets } from 'Components/organisms/AgGridEngagementFlow/flowSpecTriggerTags.util';
import './styles.scss';

interface ExpandableEngagementListProps {
    selectedFindingsOptions: {
        id: string;
        value: string;
        cid: string;
        eventType: string;
        icon: string;
    }[];
    findingsDropdownOptions: MenuItem[];
    onFindingsDropdownChange: (targetId: string, itemId: string, eventKey: string | null) => void;
    onFindingsDeleteSelectedOption: (indexToDelete: string) => void;
    onFindingsSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    findingsSearchQuery: string;
    tagBuckets: TagFilterBuckets;
    onTagBucketsChange: (buckets: TagFilterBuckets) => void;
    userCohortRows: Row[];
    setUserCohortRows: React.Dispatch<React.SetStateAction<Row[]>>;
    selectedEngagementOptions: { id: string; icon: string; value: string }[];
    setSelectedEngagementOptions: React.Dispatch<
        React.SetStateAction<
            {
                id: string;
                icon: string;
                value: string;
            }[]
        >
    >;
    dropdownEngagementOptions: MenuItem[];
}

const ExpandableEngagementList = ({
    selectedFindingsOptions,
    userCohortRows,
    setUserCohortRows,
    selectedEngagementOptions,
    setSelectedEngagementOptions,
    onFindingsDropdownChange,
    onFindingsDeleteSelectedOption,
    onFindingsSearchChange,
    findingsSearchQuery,
    tagBuckets,
    onTagBucketsChange,
    findingsDropdownOptions,
    dropdownEngagementOptions,
}: ExpandableEngagementListProps) => {
    const showTagFilters = isPendingEngagementsFilterByFindingsEnabled();

    return (
        <div className="expandable-list" data-testid="expandable-list">
            <div className="findings-tags-group">
                <FindingsExpandableComponent
                    selectedOptions={selectedFindingsOptions}
                    onFindingsDropdownChange={onFindingsDropdownChange}
                    onFindingsDeleteSelectedOption={onFindingsDeleteSelectedOption}
                    onFindingsSearchChange={onFindingsSearchChange}
                    findingsSearchQuery={findingsSearchQuery}
                    findingsDropdownOptions={findingsDropdownOptions}
                />
                {showTagFilters ? (
                    <TagFiltersExpandable tagBuckets={tagBuckets} onTagBucketsChange={onTagBucketsChange} />
                ) : null}
            </div>
            <UserCohort rows={userCohortRows} setRows={setUserCohortRows} />
            <EngagementChannelExpandable
                selectedOptions={selectedEngagementOptions}
                setSelectedOptions={setSelectedEngagementOptions}
                dropdownOptions={dropdownEngagementOptions}
            />
        </div>
    );
};

export default ExpandableEngagementList;
